import CardAtividade from './CardAtividade.component';

export default CardAtividade;
